const SignIn = () => {
  return <h1>Sign In</h1>;
};
export default SignIn;
